module.exports = __webpack_public_path__ + "img/last-bell.c37d3f93.webp";